var map = {
	"./cs/core": [
		2120,
		120
	],
	"./da/core": [
		214,
		214
	],
	"./de/core": [
		3546,
		546
	],
	"./en/core": [
		849
	],
	"./es/core": [
		7994,
		994
	],
	"./fr/core": [
		5192,
		192
	],
	"./it/core": [
		7483,
		483
	],
	"./ja/core": [
		6054,
		54
	],
	"./ko/core": [
		2914,
		914
	],
	"./pl/core": [
		7796,
		796
	],
	"./pt-BR/core": [
		9687,
		687
	],
	"./ru/core": [
		6460,
		460
	],
	"./sk/core": [
		3990,
		990
	],
	"./sv/core": [
		7954,
		954
	],
	"./uz/core": [
		637,
		637
	],
	"./zh/core": [
		9674,
		674
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;